<svg id="groin-sidebar-logo"
     xmlns="http://www.w3.org/2000/svg"
     viewBox="0 0 425.02 363.64"
     preserveAspectRatio="xMidYMid meet"
     overflow="visible"
     role="img" aria-label="Groin logo">

	<defs>
		<style>
			#pig-path {
				fill: #e43726;
				transform-origin: 212px 182px;
				animation:
					mainLoop 8s ease-in-out infinite;
			}

			/* ── LOOP PRINCIPALE toutes les 8s ── */
			@keyframes mainLoop {
				/* ░░ REPOS 0–74% ░░ */
				0%   { transform: scale(1) rotate(0deg) translateY(0); fill: #e43726; filter: none; }
				74%  { transform: scale(1) rotate(0deg) translateY(0); fill: #e43726; filter: none; }

				/* ░░ ANTICIPATION ░░ */
				76%  { transform: scale(0.93) rotate(2deg) translateY(3px); fill: #e43726; }

				/* ░░ SAUT VERS LE HAUT ░░ */
				80%  { transform: scale(1.12) rotate(-5deg) translateY(-18px); fill: #ff2255;
					filter: drop-shadow(0 0 18px rgba(220,83,114,0.9)) drop-shadow(0 0 40px rgba(220,83,114,0.4)); }

				/* ░░ RETOMBÉE ░░ */
				83%  { transform: scale(0.92) rotate(4deg) translateY(6px); fill: #e43726;
					filter: drop-shadow(0 4px 12px rgba(220,83,114,0.4)); }

				/* ░░ REBOND ░░ */
				85.5%{ transform: scale(1.06) rotate(-2deg) translateY(-6px); fill: #e8456a;
					filter: drop-shadow(0 0 10px rgba(220,83,114,0.5)); }

				/* ░░ STABILISATION ░░ */
				87%  { transform: scale(0.98) rotate(1deg) translateY(1px); fill: #e43726; filter: none; }
				88%  { transform: scale(1) rotate(0deg) translateY(0); fill: #e43726; filter: none; }

				/* ░░ WIGGLE HEAD ░░ */
				89.5%{ transform: rotate(-5deg) scale(1.02); }
				91%  { transform: rotate(5deg)  scale(1.02); }
				92%  { transform: rotate(-3deg) scale(1.01); }
				93%  { transform: rotate(2deg)  scale(1.01); }
				94%  { transform: rotate(-1deg) scale(1); }

				/* ░░ RETOUR AU CALME ░░ */
				96%  { transform: scale(1) rotate(0deg); fill: #e43726; filter: none; }
				100% { transform: scale(1) rotate(0deg); fill: #e43726; filter: none; }
			}
		</style>

		<!-- Glow doux permanent -->
		<filter id="softglow" x="-20%" y="-20%" width="140%" height="140%" color-interpolation-filters="sRGB">
			<feGaussianBlur in="SourceGraphic" stdDeviation="5" result="blur"/>
			<feColorMatrix in="blur" type="matrix"
			               values="1 0 0 0 0.86
                0 0 0 0 0.20
                0 0 0 0 0.32
                0 0 0 0 0.5" result="coloredBlur"/>
			<feMerge>
				<feMergeNode in="coloredBlur"/>
				<feMergeNode in="SourceGraphic"/>
			</feMerge>
		</filter>

		<!-- Glow intense pour le pic d'animation -->
		<filter id="bloom" x="-30%" y="-30%" width="160%" height="160%" color-interpolation-filters="sRGB">
			<feGaussianBlur in="SourceGraphic" stdDeviation="12" result="blur"/>
			<feColorMatrix in="blur" type="matrix"
			               values="1 0 0 0 1
                0 0 0 0 0.13
                0 0 0 0 0.33
                0 0 0 0 0.8" result="coloredBlur"/>
			<feMerge>
				<feMergeNode in="coloredBlur"/>
				<feMergeNode in="coloredBlur"/>
				<feMergeNode in="SourceGraphic"/>
			</feMerge>
		</filter>

		<!-- Dégradé shimmer -->
		<linearGradient id="shimmer" x1="0%" y1="0%" x2="100%" y2="100%">
			<stop offset="0%"   stop-color="#e43726"/>
			<stop offset="50%"  stop-color="#ff6b8a"/>
			<stop offset="100%" stop-color="#e43726"/>
			<animateTransform attributeName="gradientTransform" type="translate"
			                  from="-1 0" to="1 0" dur="3s" repeatCount="indefinite"/>
		</linearGradient>
	</defs>

	<!-- Halo ambiant derrière le logo -->
	<ellipse cx="212" cy="195" rx="180" ry="155"
	         fill="rgba(220,83,114,0.06)"
	         style="animation: haloPulse 4s ease-in-out infinite;">
		<animate attributeName="rx" values="170;190;170" dur="4s" repeatCount="indefinite"/>
		<animate attributeName="ry" values="145;165;145" dur="4s" repeatCount="indefinite"/>
		<animate attributeName="fill-opacity" values="0.05;0.12;0.05" dur="4s" repeatCount="indefinite"/>
	</ellipse>

	<!-- Logo path original avec filtre permanent -->
	<path id="pig-path"
	      filter="url(#softglow)"
	      d="M31.87,60.37c15.03,11.31,29.67,22.29,44.52,34.71-7.2,9.57-13.56,18.81-18.85,29.71C17.59,117.56.77,75.78.6,38.83c.93-5.79-3.2-30.49,2.4-34.49,3.86-3.89,11.98-1.81,21.88-.79,41.91,3.06,84.87,24.53,95.93,68.4,52.49-40.61,127.74-41.28,180.59-.38C313.41,19.06,366.41,3.88,414.5.1c3.2-.45,5.94.68,7.84,2.73,5.27,3.95,1,34.38,1.81,40.05-.88,36.52-19.4,78.28-59.04,83.81-21.96-45.92-31.75-16.5,19.54-63.99,3.76,1.67,6.33,4.4,9.21,7.25,3.23,1.16,6.54-41.92,7.51-43.34-15.6,2.48-29.03,6.25-43.42,9.91l9.13,9.53c-16.7,12.83-32.28,26.68-46.83,42.42,15.27,16.63,29.02,35.17,37.1,57.09l-38.09.26c-63.21-124.95-240.77-65.86-230.84,68.72,18.09,147.83,224.19,154.64,244.7,4.24-12.28-.26-40.14-.62-52.14-.14-17.86,43.82-79.69,49.73-117.26,29.25-18.46-10.81-30.98-29.78-27.55-51.05,13.02-61.57,113.45-65,143.6-15.99,0,0,79.88-.09,79.88-.09,3.98,0,8.15,1.92,8.53,6.89,2.82,36.84-6.37,74.41-26.89,105.47C206.39,480.65-56.01,252.99,101.88,88.48c-20.47-22.35-43.76-41.8-72.45-53.69M195.1,211.42c9.12-12.65-6.31-29.52-19.57-21.61-21.01,13.17,4.5,41.71,19.57,21.61ZM253.39,195.44c-15.54-21.55-41.37,7.77-19.59,20.96,12.46,6.85,27.61-8.11,19.59-20.96Z"/>

</svg>
